import { NgModule, APP_INITIALIZER, Injector, LOCALE_ID } from '@angular/core';
import { CommonModule, DatePipe, CurrencyPipe } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';
// External modules
import { ToastrModule } from 'ngx-toastr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FaIconLibrary } from "@fortawesome/angular-fontawesome";
import { faUserCircle, faPhoneAlt, faEnvelope, faSquare, faArrowCircleLeft, faArrowCircleRight, faPlus, faStar, faCog, faGauge } from "@fortawesome/pro-solid-svg-icons";
import { faEllipsisV, faSearch } from "@fortawesome/pro-regular-svg-icons";

// Framework modules
import {
	LayoutModule,
	AuthModule,
	ApiPrefixModule,
	ConfirmModalModule,
	AppStateModule,
	AdminRoleModule,
	AutocompleteDataModule,
	// ProfileModule,
	VoyagerModule,
	FloatSearchModule,
	ElevateConfigService,
	LocalStorageService,
	AuthService,
	ApiPrefixService,
	AppStateService,
	AutocompleteDataService,
	initAppAuth,
	GuidedTourModule,
	GeocodeModule,
	YardiKpiModule,
	DownloadModule,
	YardiListModule,
	SimpleDialogModule,
	SecurityModule, 
	YardiSecurityElementModule,
  MenuService
} from "yardi-angular-framework-bootstrap";
import { TranslateModule } from '@ngx-translate/core';

import { fakeBackendProvider } from './backend-less/backend';
import { OverlayModule } from '@angular/cdk/overlay';

// App modules
import { AppRoutingModule } from './app-routing.module';

// App components
import { AppComponent } from './app.component';
import { IconProviderModule } from './icon-provider.module';
import { NgIdleModule } from '@ng-idle/core';
//import { WarningDialogModule } from './pages/session-timeout/warning-dialog.module';

export function configServiceFactory(config: ElevateConfigService, injector: Injector,authService: AuthService) {
  return () => {

  return config.load(injector);
  };
}

export function initAppAuthFactory(
  authService: AuthService,
  localStorage: LocalStorageService,
  apiPrefix: ApiPrefixService,
  appState: AppStateService,
  ) {

  // Set `Elevate indicator` to localstorage so that elevate app can know
  //localStorage.set('ElevateSession', true);
  const clientpin = authService.getQueryParams('clientpin');
  const yauthLoginURL = apiPrefix.rootPath + 'yauthlogin?clientpin=' + clientpin;

  appState.set({
    appMode: appState.config.isElevateSession ? window.location.pathname.replace(/^\/+|\/$/ig, '').split('/')[0] : 'angularcore',
    loginUrl: clientpin ? yauthLoginURL :  environment.loginUrl,
  });
  if (authService.isLoggedIn()) {
    return () => initAppAuth(authService);
  } else {
    window.location.href = clientpin ? yauthLoginURL : environment.appRoot + environment.loginUrl
    return Promise.resolve();
  }
}

export function initAppFactory(
  autoCompleteData: AutocompleteDataService
) {
  return () => {
    return new Promise<void>(resolve => {
      // autoCompleteData.syncAutocompleteData();
      resolve();
    });
  };
}

@NgModule({
  imports: [
    BrowserModule,
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    // External modules
    ToastrModule.forRoot(),
    NgbModule,
    FontAwesomeModule,
    // Framework modules
    AuthModule.forRoot({
      loginUrl:  environment.loginUrl
    }),
    AdminRoleModule.forRoot(),
    LayoutModule.forRoot(),
    ApiPrefixModule.forRoot({
      rootPath: environment.appRoot + environment.apiPrefix.rootPath,
      coreRootPath: environment.apiPrefix.coreRootPath,
      connect: environment.appRoot + environment.apiPrefix.connect
    }),
    AppStateModule.forRoot({
      logo:  environment.logo,
      productName: environment.productName,
      appMode: "acqdataroomcafe",
			favIcon: environment.appRoot + environment.favIcon,
      asideFolded: false,
      year: new Date().getFullYear(),
      enableHelper: true,
      enableAnnouncement: true,
      enableAnnouncementBelowHeader: true, // TODO: implement on fw2
      homepageRoute: environment.appRoot + environment.homepageRoute,
      showCompanyProfileMenu: false,
      HideChangePassword: false,
      autoLoginWhenRedirect: false
    }),
    AutocompleteDataModule.forRoot(),
    ConfirmModalModule,
    AdminRoleModule,
    IconProviderModule,
    VoyagerModule,
    FloatSearchModule,
    GuidedTourModule,
    GeocodeModule,
    OverlayModule,
    TranslateModule.forRoot(),
    // App modules
    AppRoutingModule,
    DownloadModule,
    //WarningDialogModule,
    NgIdleModule.forRoot()
  ],
  declarations: [
    AppComponent
  ],
  providers: [
    DatePipe,
    // fakeBackendProvider,
    {
      // This must be run first
      provide: APP_INITIALIZER,
      useFactory: initAppAuthFactory,
      deps: [
        AuthService,
        LocalStorageService,
        ApiPrefixService,
        AppStateService
      ],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: configServiceFactory,
      deps: [ElevateConfigService, Injector,AuthService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initAppFactory,
      deps: [
        AutocompleteDataService
      ],
      multi: true
    },

    { provide: LOCALE_ID, useValue: 'en-US' }
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
  constructor(library: FaIconLibrary) {
		library.addIcons(faUserCircle, faSearch, faPhoneAlt, faEnvelope, faSquare, faEllipsisV, faArrowCircleLeft, faArrowCircleRight, faPlus, faStar, faCog, faGauge, );
	}
}
